var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-product"},[_vm._v("\n\t\t产品\n  \t")])}
var staticRenderFns = []

export { render, staticRenderFns }